import { takeLatest, put, select, call } from 'redux-saga/effects';
import { actions as listActions } from '../slices/RouteListSlice';
import { actions } from '../slices/RouteSlice';
import { actions as routeLineActions } from '../slices/RouteLineSlice';
import { actions as routeTicketActions } from '../slices/RouteTicketSlice';
import { actions as routeScheduleActions } from '../slices/RouteScheduleSlice';
import { actions as routeTripListActions } from '../slices/RouteTripListSlice';
import { actions as lineStopsSettingActions } from '../slices/LineStopsSettingSlice';
import { actions as tripActions } from '../slices/AssignTripSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';
import { sortBy } from 'lodash';
import busRouteApi from '../../../api/busRouteApi';
import moment from 'moment';

const getSearchCriteria = (state) => state.routeList.searchCriteria;

const getTripSearchCriteria = (state) => state.routeTripList.searchCriteria;

function* getRouteList({ payload: { page, limit, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_route')}`, {
            params: {
                page: page ? page - 1 : null,
                size: limit,
                ...filters,
            },
        });
        yield put({ type: listActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.get_list_failed.type, payload: error });
    }
}

function* getRouteTripList({ payload: { page, limit, filters } }) {
    const { routeId, tongDaRouteId, ...filterData } = filters;
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_route')}/${routeId}/trips`, {
            params: {
                ...filterData,
                page: page ? page - 1 : null,
                size: limit,
            },
        });
        yield put({ type: routeTripListActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: routeTripListActions.get_list_failed.type, payload: error });
    }
}

function* exportRouteTripList({ payload: { page, limit, filters } }) {
    const { routeId, tongDaRouteId, ...filterData } = filters;
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_route')}/${routeId}/trips`, {
            params: {
                ...filterData,
                page: page ? page - 1 : null,
                size: limit,
                export: true,
            },
        });

        if (response?.data) {
            NotificationHandler.notifyDownloadBox(response.data);
            yield put({ type: routeTripListActions.export_succeed.type });
        } else {
            throw new Error('URL download không hợp lệ');
        }
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: routeTripListActions.export_failed.type, payload: error });
    }
}

function* createRoute({ payload: { params } }) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_route')}`, {
            ...params,
        });
        yield put({ type: actions.create_route_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Thêm thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.create_route_failed.type, payload: error });
    }
}

function* updateRoute({ payload: { params } }) {
    try {
        const response = yield NetworkHandler.put(`${config.getUrl('bus_route')}/${params.id}`, {
            ...params,
        });
        yield put({ type: actions.create_route_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.create_route_failed.type, payload: error });
    }
}

function* updateRouteLine({ payload: { params } }) {
    try {
        const { newLines, lines, id } = params;
        const createLines = newLines.filter((s) => !s.id) || [];
        const updateLines = newLines.filter((s) => !!s.id) || [];
        const updateLineIds = updateLines.map((i) => i.id) || [];
        const deleleLines = lines.filter((s) => !updateLineIds.includes(s.id)) || [];
        for (let i = 0; i < createLines.length; i++) {
            yield NetworkHandler.post(`${config.getUrl('bus_route')}/${id}/lines`, {
                ...createLines[i],
            });
        }
        for (let i = 0; i < updateLines.length; i++) {
            yield NetworkHandler.put(`${config.getUrl('bus_route')}/${id}/lines/${updateLines[i].id}`, {
                ...updateLines[i],
            });
        }
        for (let i = 0; i < deleleLines.length; i++) {
            yield NetworkHandler.delete(`${config.getUrl('bus_route')}/${id}/lines/${deleleLines[i].id}`);
        }
        yield put({ type: routeLineActions.update_route_line_succeed.type, payload: {} });
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: routeLineActions.update_route_line_failed.type, payload: error });
    }
}

function* updateRouteTicket({ payload: { params } }) {
    try {
        const { newTickets, tickets, id } = params;

        let error = false;
        let dataUpdate = [];

        for (let i = 0; i < newTickets.length; i++) {
            const ticket = newTickets[i];
            if (ticket.name == '') {
                NotificationHandler.notifyError('Vui lòng nhập thông tin trước khi lưu!');
                yield put({ type: routeTicketActions.update_route_ticket_failed.type, payload: 'Vui lòng nhập thông tin trước khi lưu!' });
                error = true;
                break;
            }
            for (let j = 0; j < tickets.length; j++) {
                const originTicket = tickets[j];
                if (ticket.id == originTicket.id) {
                    if (ticket.name != originTicket.name || ticket.type != originTicket.type || ticket.price != originTicket.price || ticket.distance != originTicket.distance) {
                        dataUpdate = [...dataUpdate, ticket];
                    }
                    break;
                }
            }
        }

        if (!error) {
            const createTickets = newTickets.filter((s) => !s.id) || [];
            const updateTickets = newTickets.filter((s) => !!s.id) || [];
            const updateTicketIds = updateTickets.map((i) => i.id) || [];
            const deleleTickets = tickets.filter((s) => !updateTicketIds.includes(s.id)) || [];

            for (let i = 0; i < createTickets.length; i++) {
                yield NetworkHandler.post(`${config.getUrl('bus_route')}/${id}/tickets`, {
                    ...createTickets[i],
                });
            }
            for (let i = 0; i < dataUpdate.length; i++) {
                yield NetworkHandler.put(`${config.getUrl('bus_route')}/${id}/tickets/${dataUpdate[i].id}`, {
                    ...dataUpdate[i],
                });
            }
            for (let i = 0; i < deleleTickets.length; i++) {
                yield NetworkHandler.delete(`${config.getUrl('bus_route')}/${id}/tickets/${deleleTickets[i].id}`);
            }
            yield put({ type: routeTicketActions.update_route_ticket_succeed.type, payload: {} });
            NotificationHandler.notifySuccess('Cập nhật thành công!');
            const searchCriteria = yield select(getSearchCriteria);
            yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
            yield ModalHandler.closeAllModal();
        }
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: routeTicketActions.update_route_ticket_failed.type, payload: error });
    }
}

function* updateRouteTicketAutoPrice({ payload: { params } }) {
    try {
        const { route_auto_price, id } = params;
        for (let i = 0; i < route_auto_price.length; i++) {
            const body = {
                price: route_auto_price[i].price,
                type: route_auto_price[i].type,
            };
            yield NetworkHandler.post(`${config.getUrl('bus_route')}/${id}/autoPrice`, {
                ...body,
            });
        }
        yield put({ type: routeTicketActions.update_route_ticket_succeed.type, payload: {} });
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: routeTicketActions.update_route_ticket_failed.type, payload: error });
    }
}
function* switchAutoPrice({ payload: { params } }) {
    try {
        const { switchAutoPrice, id } = params;
        const body = {
            isAutoPrice: switchAutoPrice,
        };
        yield NetworkHandler.put(`${config.getUrl('bus_route')}/${id}/route/autoPrice`, {
            ...body,
        });
        NotificationHandler.notifySuccess('Thay đổi thành công');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: routeTicketActions.update_route_ticket_failed.type, payload: error });
    }
}

function* updateLineStopsSetting({ payload: { params } }) {
    try {
        const { selectedLine, id } = params;
        const { newStops, stops } = selectedLine;
        const createStops = newStops.filter((s) => `${s.id}`.includes('new')) || [];
        const updateStops = newStops.filter((s) => !`${s.id}`.includes('new')) || [];
        const updateStopIds = updateStops.map((i) => i.id) || [];
        const deleleStops = stops.filter((s) => !updateStopIds.includes(s.id)) || [];

        let sortStopList = [...updateStops];

        for (let i = 0; i < createStops.length; i++) {
            const newStop = yield NetworkHandler.post(`${config.getUrl('bus_route')}/${id}/lines/${selectedLine.id}/stops`, {
                ...createStops[i],
            });
            sortStopList.push({
                ...createStops[i],
                ...newStop.data,
            });
        }
        for (let i = 0; i < updateStops.length; i++) {
            yield NetworkHandler.put(`${config.getUrl('bus_route')}/${id}/lines/${selectedLine.id}/stops/${updateStops[i].id}`, {
                ...updateStops[i],
            });
        }
        for (let i = 0; i < deleleStops.length; i++) {
            yield NetworkHandler.delete(`${config.getUrl('bus_route')}/${id}/lines/${selectedLine.id}/stops/${deleleStops[i].id}`);
        }
        sortStopList = sortBy(sortStopList, ['order']);
        yield NetworkHandler.put(`${config.getUrl('bus_route')}/${id}/lines/${selectedLine.id}/stop-map`, {
            stop_ids_map: sortStopList.map((item) => (item?.stop?.id ? +item.stop.id : 0)),
        });
        yield put({ type: lineStopsSettingActions.update_line_stops_setting_succeed.type, payload: {} });
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: lineStopsSettingActions.update_line_stops_setting_failed.type, payload: error });
    }
}

function* updateRouteSchedule({ payload: { params } }) {
    try {
        const { newSchedules, schedules, id } = params;
        const createSchedules = newSchedules.filter((s) => !s.id) || [];
        const updateSchedules = newSchedules.filter((s) => !!s.id) || [];
        const updateScheduleIds = updateSchedules.map((i) => i.id) || [];
        const deleleSchedules = schedules.filter((s) => !updateScheduleIds.includes(s.id)) || [];
        for (let i = 0; i < createSchedules.length; i++) {
            yield NetworkHandler.post(`${config.getUrl('bus_route')}/${id}/schedules`, {
                ...createSchedules[i],
            });
        }
        for (let i = 0; i < updateSchedules.length; i++) {
            yield NetworkHandler.put(`${config.getUrl('bus_route')}/${id}/schedules/${updateSchedules[i].id}`, {
                ...updateSchedules[i],
            });
        }
        for (let i = 0; i < deleleSchedules.length; i++) {
            yield NetworkHandler.delete(`${config.getUrl('bus_route')}/${id}/schedules/${deleleSchedules[i].id}`);
        }
        yield put({ type: routeScheduleActions.update_route_schedule_succeed.type, payload: {} });
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: routeScheduleActions.update_route_schedule_failed.type, payload: error });
    }
}

function* deleteRoute({ payload: { id } }) {
    try {
        const response = yield NetworkHandler.delete(`${config.getUrl('bus_route')}/${id}`);
        yield put({ type: actions.delete_route_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Xoá thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.delete_route_failed.type, payload: error });
    }
}

function* assignTrip({ payload: { params } }) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_route')}/${params.route_id}/trips`, {
            ...params,
        });
        // yield NetworkHandler.post(`${config.getUrl('directorate_general')}`, {
        //     ...params,
        //     trip_code: response?.data?.id,
        // });

        yield put({ type: tripActions.assign_trip_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Thành công!');
        const searchCriteria = yield select(getTripSearchCriteria);
        yield put({ type: routeTripListActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripActions.assign_trip_failed.type, payload: error });
    }
}

function* assignMultipleTrip({ payload: { params } }) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_route')}/multi-trip/assign`, {
            ...params,
        });

        yield put({ type: tripActions.assign_multi_trip_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Import thành công nhiều chuyến vào phân công Ngày ' + moment(params.day).format('DD/MM/YYYY'));
        const searchCriteria = yield select(getTripSearchCriteria);
        yield put({ type: routeTripListActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripActions.assign_multi_trip_failed.type, payload: error });
    }
}

function* updateStatusAssignTrip({ payload: { params } }) {
    try {
        const { code, route_id, status, note } = params;
        const response = yield NetworkHandler.put(`${config.getUrl('bus_route')}/${route_id}/trips/${code}`, {
            note: note,
            status,
        });
        yield put({ type: tripActions.update_status_assign_trip_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getTripSearchCriteria);
        yield put({ type: routeTripListActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripActions.update_status_assign_trip_failed.type, payload: error });
    }
}

function* updateAssignTrip({ payload: { params } }) {
    try {
        const { code, ...data } = params;
        const response = yield NetworkHandler.put(`${config.getUrl('bus_route')}/${data.route_id}/trips/${code}`, {
            ...data,
        });
        // yield NetworkHandler.post(`${config.getUrl('directorate_general')}`, {
        //     ...params,
        //     trip_code: code,
        // });
        yield put({ type: tripActions.update_assign_trip_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getTripSearchCriteria);
        yield put({ type: routeTripListActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripActions.update_assign_trip_failed.type, payload: error });
    }
}

function* deleteAssignTrip({ payload: { params } }) {
    try {
        const { code, route_id, note } = params;
        yield NetworkHandler.delete(`${config.getUrl('bus_route')}/${route_id}/trips/${code}`, { data: { note: note } });
        yield put({ type: tripActions.delete_assign_trip_succeed.type, payload: {} });
        NotificationHandler.notifySuccess('Xoá thành công!');
        const searchCriteria = yield select(getTripSearchCriteria);
        yield put({ type: routeTripListActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripActions.delete_assign_trip_failed.type, payload: error });
    }
}

function* deleteAssignTripMultiple({ payload: { params, callBack } }) {
    try {
        const { routeId, arrayId, ...rest } = params;
        const { deleteAssignTripMultiptle } = busRouteApi;
        const res = yield call(deleteAssignTripMultiptle, routeId, { trip_codes: arrayId, ...rest });
        NotificationHandler.notifySuccess('Bạn đã xóa chuyến thành công');
        yield put({ type: tripActions.delete_assign_trip_multiple_succeed.type });

        if (callBack) {
            callBack();
        }
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripActions.delete_assign_trip_multiple_failed.type, payload: error });
    }
}

function* copyAssignTrip({ payload: { params } }) {
    try {
        yield NetworkHandler.post(`${config.getUrl('bus_route')}/${params.route_id}/trips/copy`, {
            ...params,
        });
        yield put({ type: tripActions.copy_assign_trip_succeed.type, payload: {} });
        NotificationHandler.notifySuccess('Sao chép thành công!');
        const searchCriteria = yield select(getTripSearchCriteria);
        yield put({ type: routeTripListActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripActions.copy_assign_trip_failed.type, payload: error });
    }
}

function* getTongdaPreview({ payload }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('get_preview_tongda')}`, {
            params: {
                ...payload,
            },
        });
        yield put({ type: tripActions.get_tong_da_preview_success.type, payload: { dataTongDa: response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripActions.get_tong_da_preview_fail.type, payload: error });
    }
}

function* syncTongDa({ payload }) {
    try {
        yield NetworkHandler.get(`${config.getUrl('sync_tongda')}`, {
            params: payload,
        });
        NotificationHandler.notifySuccess('Đồng bộ dữ liệu thành công');
        yield put({ type: tripActions.sync_tong_da_success.type });
        yield ModalHandler.closeAllModal();
        const searchCriteria = yield select(getTripSearchCriteria);
        yield put({ type: routeTripListActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripActions.sync_tong_da_fail.type, payload: error });
    }
}

function* getAssignmentHistory({ payload }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('get_assignment_history')}`, {
            params: payload,
        });
        yield put({ type: tripActions.get_assignment_history_success.type, payload: { dataHistory: response?.data?.items, total: response?.data?.total, searchCriteria: payload } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripActions.get_assignment_history_fail.type, payload: error });
    }
}
function* editMulTrip({ payload }) {
    try {
        const { route_id, body } = payload;
        yield NetworkHandler.put(`${config.getUrl('bus_route')}/${route_id}/multi-trips`, { route_trips: [...body] });
        yield put({ type: tripActions.edit_muti_trip_success.type });
        yield ModalHandler.closeAllModal();
        const searchCriteria = yield select(getTripSearchCriteria);
        yield put({ type: routeTripListActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripActions.edit_muti_trip_fail.type, payload: error });
    }
}
// function* getSchedule({ payload }) {
//     try {
//         const { routeId, page, size } = payload;

//         const { getRouteSchedule } = busRouteApi;
//         const response = yield call(getRouteSchedule, routeId, page, size);
//         yield put({ type: routeScheduleActions.get_schedule_success.type, payload: { data: response?.data?.items } });
//     } catch (error) {
//         yield put({ type: routeScheduleActions.get_schedule_failed.type, payload: error });
//     }
// }

function* updateStatusLostTrip({ payload: { body } }) {
    try {
        yield NetworkHandler.post(`${config.getUrl('update_lost_trip_propose')}`, {
            ...body,
        });

        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getTripSearchCriteria);
        yield put({ type: routeTripListActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        // yield put({ type: actions.create_route_failed.type, payload: error });
    }
}

function* confirmTime({ payload: { body } }) {
    try {
        const { confirmTime } = busRouteApi;
        const res = yield call(confirmTime, { ...body });
        NotificationHandler.notifySuccess(res?.message);
        yield put({ type: routeTripListActions.confirm_time_success.type });
        const searchCriteria = yield select(getTripSearchCriteria);
        yield put({ type: routeTripListActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: routeTripListActions.confirm_time_fail.type });
    }
}
function* confirmNoReturn({ payload: { body } }) {
    try {
        const { confirmNoReturn } = busRouteApi;
        const res = yield call(confirmNoReturn, { ...body });
        NotificationHandler.notifySuccess(res?.message);
        yield put({ type: routeTripListActions.confirm_no_return_success.type });
        const searchCriteria = yield select(getTripSearchCriteria);
        yield put({ type: routeTripListActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: routeTripListActions.confirm_no_return_fail.type });
    }
}
function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getRouteList);
    yield takeLatest(actions.create_route.type, createRoute);
    yield takeLatest(actions.update_route.type, updateRoute);
    yield takeLatest(actions.delete_route.type, deleteRoute);
    yield takeLatest(routeLineActions.update_route_line.type, updateRouteLine);
    yield takeLatest(routeTicketActions.update_route_ticket.type, updateRouteTicket);
    yield takeLatest(routeTicketActions.update_route_ticket_auto_price.type, updateRouteTicketAutoPrice);
    yield takeLatest(routeTicketActions.switch_auto_price.type, switchAutoPrice);
    yield takeLatest(routeScheduleActions.update_route_schedule.type, updateRouteSchedule);
    yield takeLatest(lineStopsSettingActions.update_line_stops_setting.type, updateLineStopsSetting);
    yield takeLatest(routeTripListActions.get_list.type, getRouteTripList);
    yield takeLatest(routeTripListActions.export_request.type, exportRouteTripList);
    yield takeLatest(tripActions.assign_trip.type, assignTrip);
    yield takeLatest(tripActions.assign_multi_trip.type, assignMultipleTrip);
    yield takeLatest(tripActions.update_assign_trip.type, updateAssignTrip);
    yield takeLatest(tripActions.update_status_assign_trip.type, updateStatusAssignTrip);
    yield takeLatest(tripActions.delete_assign_trip.type, deleteAssignTrip);
    yield takeLatest(tripActions.copy_assign_trip.type, copyAssignTrip);
    yield takeLatest(tripActions.delete_assign_trip_multiple.type, deleteAssignTripMultiple);
    yield takeLatest(tripActions.get_tong_da_preview.type, getTongdaPreview);
    yield takeLatest(tripActions.sync_tong_da.type, syncTongDa);
    yield takeLatest(tripActions.get_assignment_history.type, getAssignmentHistory);
    yield takeLatest(tripActions.edit_muti_trip.type, editMulTrip);
    // yield takeLatest(routeScheduleActions.get_schedule.type, getSchedule);
    yield takeLatest(routeTripListActions.update_loss_of_flight.type, updateStatusLostTrip);
    yield takeLatest(routeTripListActions.confirm_time.type, confirmTime);
    yield takeLatest(routeTripListActions.confirm_no_return.type, confirmNoReturn);
}

export default watchRequestDetail;
